import {
  GOT_POP_VIDEOS,
  GOT_CHANNELS,
  GOT_HOME_VIDEOS,
  GETTING_POP_VIDEOS,
  GETTING_HOME_VIDEOS
} from "../Actions/actionTypes";

const initalState = {
  loading: true,
  pageNum: 0,
  data: { Trending: { data: [], loading: null, videoCatId: 0 } },
  error: null
};
export default (state = initalState, action) => {
  switch (action.type) {
    case GOT_CHANNELS:
      return fillWithIds(state, action.payload);
    case GETTING_POP_VIDEOS:
      return {
        ...state,
        data: {
          ...state.data,
          Trending: { ...state.data.Trending, loading: action.payload }
        }
      };
    case GOT_POP_VIDEOS:
      return fillWithPopVideo(state, action.payload);
    case GETTING_HOME_VIDEOS:
      return changeGettingVidoes(state, action.payload);
    case GOT_HOME_VIDEOS:
      return fillWithVideos(state, action.payload);
    default:
      return state;
  }
};
function changeGettingVidoes(state, payload) {
  const pS = { ...state };
  pS.data[payload.title].loading = payload.val;
  return pS;
}
function fillWithPopVideo(state, payload) {
  return {
    ...state,
    data: {
      ...state.data,
      Trending: {
        ...state.data.Trending,
        data: [...payload.items]
      }
    }
  };
}
function fillWithVideos(state, payload) {
  const pS = { ...state };
  for (let keys in pS.data) {
    if (pS.data[keys].videoCatId === payload.id) {
      pS.data[keys] = { ...state.data[keys], data: [...payload.data.items] };
    }
  }
  return pS;
}
function fillWithIds(state, payload) {
  let pS = { ...state, loading: false, pageNum: 1 };
  const channels = payload.items.map(ch => {
    return {
      channelId: ch.snippet.channelId,
      videoCatId: ch.id,
      title: ch.snippet.title
    };
  });
  channels.forEach(({ videoCatId, channelId, title }) => {
    pS.data[title] = { videoCatId, channelId, data: [], loading: null };
  });
  return pS;
}
